import React, { useState, useEffect, useCallback } from 'react'
import { Container, Table, Button, Modal, Form, Badge, InputGroup } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import axios from 'axios'
import V2Layout from '../components/V2Layout'
import './Admin.css'

const API = ''


const CertificationsAdminScreen = () => {
    const [certifications, setCertifications] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [editCert, setEditCert] = useState(null)
    const [uploading, setUploading] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const [deleteTarget, setDeleteTarget] = useState(null)

    const [form, setForm] = useState({
        code: '',
        title: '',
        issuing_body: '',
        description: '',
        date_issued: '',
        expiry_date: '',
        location: 'Lincoln, CA',
        show_on_certifications: true,
        show_on_quality: true,
        file_path: '',
        sort_order: 0
    })

    const load = useCallback(() => {
        axios.get(`${API}/api/certifications?all=1`)
            .then(r => setCertifications(r.data))
            .catch(err => console.error('Error loading certifications:', err))
    }, [])

    useEffect(() => {
        load()
    }, [load])

    const openAdd = () => {
        setEditCert(null)
        setForm({
            code: '',
            title: '',
            issuing_body: '',
            description: '',
            date_issued: '',
            expiry_date: '',
            location: 'Lincoln, CA',
            show_on_certifications: true,
            show_on_quality: true,
            file_path: '',
            sort_order: certifications.length
        })
        setShowModal(true)
    }

    const openEdit = (c) => {
        setEditCert(c)
        setForm({
            code: c.code || '',
            title: c.title || '',
            issuing_body: c.issuing_body || '',
            description: c.description || '',
            date_issued: c.date_issued || '',
            expiry_date: c.expiry_date || '',
            location: c.location || 'Lincoln, CA',
            show_on_certifications: c.show_on_certifications === 1,
            show_on_quality: c.show_on_quality === 1,
            file_path: c.file_path || '',
            sort_order: c.sort_order || 0
        })
        setShowModal(true)
    }

    const handleFileUpload = async (e) => {
        const file = e.target.files[0]
        if (!file) return
        
        setUploading(true)
        const fd = new FormData()
        fd.append('file', file)
        try {
            const res = await axios.post(`${API}/api/certifications/upload`, fd, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            setForm(prev => ({ ...prev, file_path: res.data.url }))
        } catch (err) {
            console.error('Upload failed:', err)
            alert('File upload failed. Only PDF or image files are allowed.')
        } finally {
            setUploading(false)
        }
    }

    const save = async (e) => {
        e.preventDefault()
        if (!form.code || !form.title) {
            alert('Code/Standard and Title are required.')
            return
        }

        try {
            if (editCert) {
                await axios.put(`${API}/api/certifications/${editCert.id}`, form)
            } else {
                await axios.post(`${API}/api/certifications`, form)
            }
            setShowModal(false)
            load()
        } catch (err) {
            console.error('Error saving certification:', err)
            alert('Failed to save certification.')
        }
    }

    const confirmDelete = async () => {
        if (!deleteTarget) return
        try {
            await axios.delete(`${API}/api/certifications/${deleteTarget.id}`)
            setShowDelete(false)
            setDeleteTarget(null)
            load()
        } catch (err) {
            console.error('Error deleting certification:', err)
            alert('Failed to delete certification.')
        }
    }

    return (
        <V2Layout pageClass="pfc-admin">
            <style>{`
                .pfc-admin-container {
                    padding: 3rem 0 5rem;
                    background-color: #faf9f6;
                    min-height: 80vh;
                }
                .pfc-admin-card {
                    background: #fff;
                    border: 1px solid #e5e3dd;
                    border-radius: 8px;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
                    padding: 32px;
                    margin-bottom: 24px;
                }
                .pfc-admin-table {
                    border-collapse: separate;
                    border-spacing: 0;
                    border: 1px solid #e5e3dd;
                    border-radius: 6px;
                    overflow: hidden;
                    background-color: #fff;
                    margin-top: 1.5rem;
                }
                .pfc-admin-table thead th {
                    background-color: #26215C !important;
                    color: #fff !important;
                    font-family: var(--pfc-mono, monospace);
                    font-size: 11px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    font-weight: 600;
                    border: none;
                    padding: 12px 16px;
                }
                .pfc-admin-table tbody td {
                    padding: 12px 16px;
                    vertical-align: middle;
                    font-size: 14px;
                    color: #333;
                    border-bottom: 1px solid #f1efe8;
                }
                .pfc-admin-table tbody tr:last-child td {
                    border-bottom: none;
                }
                .pfc-admin-table tbody tr {
                    transition: background-color 0.15s ease;
                }
                .pfc-admin-table tbody tr:hover {
                    background-color: rgba(38, 33, 148, 0.01) !important;
                }
                .btn-pfc-primary {
                    background-color: #26215C !important;
                    border-color: #26215C !important;
                    color: #fff !important;
                    font-family: var(--pfc-mono, monospace);
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    padding: 8px 16px;
                    border-radius: 4px;
                    font-weight: 600;
                    transition: all 0.2s ease;
                }
                .btn-pfc-primary:hover, .btn-pfc-primary:focus {
                    background-color: #1a1645 !important;
                    border-color: #1a1645 !important;
                    color: #fff !important;
                    box-shadow: 0 4px 12px rgba(38, 33, 92, 0.15);
                }
                .btn-pfc-secondary {
                    background-color: #fff !important;
                    border-color: #ced4da !important;
                    color: #5c5a54 !important;
                    font-family: var(--pfc-mono, monospace);
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    padding: 8px 16px;
                    border-radius: 4px;
                    font-weight: 600;
                    transition: all 0.2s ease;
                }
                .btn-pfc-secondary:hover {
                    background-color: #faf9f6 !important;
                    border-color: #adb5bd !important;
                    color: #333 !important;
                }
                .badge-visible {
                    background-color: #0F6E56;
                    color: #fff;
                }
                .badge-hidden {
                    background-color: #BA7517;
                    color: #fff;
                }
            `}</style>
            
            <section className="pfc-admin-container">
                <Container>
                    <div className="pfc-admin-card">
                        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                            <div>
                                <h1 style={{ color: '#26215C', fontSize: '2rem', margin: 0, fontWeight: 700 }}>Certifications Admin</h1>
                                <p className="text-muted mb-0 mt-1" style={{ fontSize: '13px' }}>
                                    Manage quality standard certifications displayed on the Certifications and Quality pages.
                                </p>
                            </div>
                            <Button className="btn-pfc-primary" onClick={openAdd}>
                                + Add Certification
                            </Button>
                        </div>

                        {/* Top sub-navigation bar */}
                        <div className="d-flex gap-3 mb-4 align-items-center pfc-admin-subnav">
                            <Link to="/admin" className="pfc-admin-subnav-link">Dashboard</Link>
                            <span className="pfc-admin-subnav-sep">|</span>
                            <Link to="/products/admin" className="pfc-admin-subnav-link">Products Admin</Link>
                            <span className="pfc-admin-subnav-sep">|</span>
                            <Link to="/capabilities/admin" className="pfc-admin-subnav-link">Capabilities Admin</Link>
                            <span className="pfc-admin-subnav-sep">|</span>
                            <Link to="/news/admin" className="pfc-admin-subnav-link">News Admin</Link>
                            <span className="pfc-admin-subnav-sep">|</span>
                            <Link to="/story/admin" className="pfc-admin-subnav-link">Timeline Admin</Link>
                            <span className="pfc-admin-subnav-sep">|</span>
                            <Link to="/certifications/admin" className="pfc-admin-subnav-link active">Certifications Admin</Link>
                        </div>

                        <Table bordered hover responsive className="pfc-admin-table">
                            <thead>
                                <tr>
                                    <th style={{ width: '80px' }}>Sort</th>
                                    <th style={{ width: '150px' }}>Code / Standard</th>
                                    <th>Title &amp; Issuing Body</th>
                                    <th>Physical Location</th>
                                    <th style={{ width: '130px' }}>Show on Certs</th>
                                    <th style={{ width: '130px' }}>Show on Quality</th>
                                    <th>Attachment</th>
                                    <th style={{ width: '150px' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {certifications.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className="text-center py-4 text-muted">
                                            No certifications found. Click "+ Add Certification" to create one.
                                        </td>
                                    </tr>
                                ) : (
                                    certifications.map(c => (
                                        <tr key={c.id}>
                                            <td className="text-center font-monospace">{c.sort_order}</td>
                                            <td>
                                                <strong>{c.code}</strong>
                                            </td>
                                            <td>
                                                <div style={{ fontWeight: 600 }}>{c.title}</div>
                                                <div className="text-muted" style={{ fontSize: '11px' }}>{c.issuing_body}</div>
                                            </td>
                                            <td>{c.location}</td>
                                            <td className="text-center">
                                                <Badge className={c.show_on_certifications === 1 ? 'badge-visible' : 'badge-hidden'}>
                                                    {c.show_on_certifications === 1 ? 'Yes' : 'No'}
                                                </Badge>
                                            </td>
                                            <td className="text-center">
                                                <Badge className={c.show_on_quality === 1 ? 'badge-visible' : 'badge-hidden'}>
                                                    {c.show_on_quality === 1 ? 'Yes' : 'No'}
                                                </Badge>
                                            </td>
                                            <td>
                                                {c.file_path ? (
                                                    <a 
                                                        href={`${API}/${c.file_path}`} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        style={{ color: '#534AB7', textDecoration: 'underline', fontSize: '12px' }}
                                                    >
                                                        View Certificate File
                                                    </a>
                                                ) : (
                                                    <span className="text-muted" style={{ fontSize: '12px', fontStyle: 'italic' }}>None</span>
                                                )}
                                            </td>
                                            <td>
                                                <Button size="sm" variant="outline-primary" onClick={() => openEdit(c)} className="me-2" style={{ fontSize: '11px' }}>
                                                    Edit
                                                </Button>
                                                <Button size="sm" variant="outline-danger" onClick={() => { setDeleteTarget(c); setShowDelete(true) }} style={{ fontSize: '11px' }}>
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Container>
            </section>

            {/* ── Add/Edit Modal ── */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                <Form onSubmit={save}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: '#26215C', fontWeight: 700 }}>
                            {editCert ? 'Edit Certification' : 'Add New Certification'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label style={{ fontWeight: 600 }}>Code / Standard *</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        value={form.code} 
                                        onChange={e => setForm({ ...form, code: e.target.value })} 
                                        placeholder="e.g. ISO 9001:2015, AS9100D" 
                                        required 
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label style={{ fontWeight: 600 }}>Title *</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        value={form.title} 
                                        onChange={e => setForm({ ...form, title: e.target.value })} 
                                        placeholder="e.g. Quality Management System" 
                                        required 
                                    />
                                </Form.Group>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label style={{ fontWeight: 600 }}>Issuing Body</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        value={form.issuing_body} 
                                        onChange={e => setForm({ ...form, issuing_body: e.target.value })} 
                                        placeholder="e.g. ANAB, TÜV SÜD" 
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label style={{ fontWeight: 600 }}>Physical Facility / Location</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        value={form.location} 
                                        onChange={e => setForm({ ...form, location: e.target.value })} 
                                        placeholder="e.g. Lincoln, CA or All Facilities" 
                                    />
                                </Form.Group>
                            </div>
                        </div>

                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontWeight: 600 }}>Description</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={3} 
                                value={form.description} 
                                onChange={e => setForm({ ...form, description: e.target.value })} 
                                placeholder="Describe the scope or details of the certification..." 
                            />
                        </Form.Group>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label style={{ fontWeight: 600 }}>Date Issued</Form.Label>
                                    <Form.Control 
                                        type="date" 
                                        value={form.date_issued} 
                                        onChange={e => setForm({ ...form, date_issued: e.target.value })} 
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label style={{ fontWeight: 600 }}>Expiration Date</Form.Label>
                                    <Form.Control 
                                        type="date" 
                                        value={form.expiry_date} 
                                        onChange={e => setForm({ ...form, expiry_date: e.target.value })} 
                                    />
                                </Form.Group>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <Form.Group>
                                    <Form.Label style={{ fontWeight: 600 }}>Sort Order</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        value={form.sort_order} 
                                        onChange={e => setForm({ ...form, sort_order: parseInt(e.target.value, 10) || 0 })} 
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-8 mb-3 d-flex align-items-end">
                                <div className="d-flex gap-4 w-100">
                                    <Form.Check 
                                        type="checkbox" 
                                        id="show_certs_check" 
                                        label="Show on Certifications Page" 
                                        checked={form.show_on_certifications} 
                                        onChange={e => setForm({ ...form, show_on_certifications: e.target.checked })} 
                                        style={{ fontWeight: 500 }}
                                    />
                                    <Form.Check 
                                        type="checkbox" 
                                        id="show_qual_check" 
                                        label="Show on Quality Page" 
                                        checked={form.show_on_quality} 
                                        onChange={e => setForm({ ...form, show_on_quality: e.target.checked })} 
                                        style={{ fontWeight: 500 }}
                                    />
                                </div>
                            </div>
                        </div>

                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontWeight: 600 }}>Certificate File (PDF or Image)</Form.Label>
                            <InputGroup>
                                <Form.Control 
                                    type="file" 
                                    onChange={handleFileUpload} 
                                    accept=".pdf,image/*" 
                                />
                            </InputGroup>
                            {uploading && <Form.Text className="text-primary">Uploading file...</Form.Text>}
                            {form.file_path && !uploading && (
                                <div className="mt-2 d-flex align-items-center justify-content-between p-2" style={{ backgroundColor: '#f4f3f8', borderRadius: '4px' }}>
                                    <a 
                                        href={`${API}/${form.file_path}`} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={{ color: '#534AB7', fontSize: '12px', fontWeight: 500 }}
                                    >
                                        📄 {form.file_path.split('/').pop()}
                                    </a>
                                    <Button 
                                        size="sm" 
                                        variant="link" 
                                        onClick={() => setForm({ ...form, file_path: '' })}
                                        className="text-danger p-0"
                                        style={{ fontSize: '11px', textDecoration: 'none' }}
                                    >
                                        Remove File
                                    </Button>
                                </div>
                            )}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn-pfc-secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                        <Button type="submit" className="btn-pfc-primary">
                            {uploading ? 'Uploading...' : 'Save Certification'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* ── Delete Confirmation Modal ── */}
            <Modal show={showDelete} onHide={() => setShowDelete(false)} centered size="sm">
                <Modal.Header closeButton>
                    <Modal.Title style={{ color: '#993C1D', fontWeight: 700, fontSize: '1.2rem' }}>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontSize: '13px' }}>
                    Are you sure you want to delete certification <strong>{deleteTarget?.code}</strong>? This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-pfc-secondary" size="sm" onClick={() => setShowDelete(false)}>Cancel</Button>
                    <Button variant="danger" size="sm" style={{ fontFamily: 'var(--pfc-mono, monospace)', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.05em', padding: '8px 16px' }} onClick={confirmDelete}>Delete</Button>
                </Modal.Footer>
            </Modal>
        </V2Layout>
    )
}

export default CertificationsAdminScreen
